import React from 'react'
import WatfordComp from '../../components/sponsorships/WatfordFC.jsx'

const WatfordFC = () => {
  return (
    <WatfordComp/>
  )
}

export default WatfordFC